module.exports = __webpack_public_path__ + "img/Group_39931@2x.f736a743.png";